import { ContentType } from "@src/api/graphql-codegen";

type PresentationModule =
  | { type?: ContentType | null; lastInLesson?: boolean | null }
  | null
  | undefined;

/**
 * OP-3255: true when the Lesson Presentation list has content and every item
 * is a Survey (Form) module. Lesson Materials are not part of this check.
 * The closing "Lesson Complete" slide (`lastInLesson`) is not lesson content;
 * the app already drops it from progress counts, so it is ignored here too.
 * Used to disable the Absent Student share link for survey-only lessons.
 */
export const isSurveyOnlyPresentation = (
  modules?: ReadonlyArray<PresentationModule> | null,
): boolean => {
  const content = (modules ?? []).filter((m) => m && !m.lastInLesson);
  return content.length > 0 && content.every((m) => m?.type === ContentType.FORM);
};
